class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.productContainer = document.querySelector('[data-product-container] .product-form') || null;
    this.addTocarBtn = this.querySelector('[data-sticky-addtocart]') || null;
    this.globaleHeader = document.querySelector('.section-header');
    this.termsCheckbox = document.querySelector('[data-pdp-tnc]');
    this.productColor = this.querySelector('[data-sticky-product-color]');
    this.productSize = this.querySelector('[data-sticky-product-size]');
    this.metafieldMap = this.parseMetafieldMap(this.dataset.metafieldMap || '');
  }

  connectedCallback() {
    if (this.productContainer) {
      this.observeProductContainer();
      if (this.addTocarBtn) {
        this.addTocarBtn.addEventListener('click', this.handleAddToCart.bind(this));
      }
    }

    // Listen for variant change and ATC events
    if (typeof eventBus !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      eventBus.subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      eventBus.subscribe(PUB_SUB_EVENTS.productATC, this.handleProductATC.bind(this));
    }
  }

  handleAddToCart(e) {
    if (this.termsCheckbox && !this.termsCheckbox.checked) {
      e.preventDefault();
      e.stopPropagation();
      this.addTocarBtn.classList.remove('loading');
      this.termsCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Show error message if not already shown
      const tncContainer = this.termsCheckbox.closest('.pdp-tnc');
      if (tncContainer && !tncContainer.querySelector('.terms-error')) {
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('terms-error', 'text-danger', 'mt-2');
        errorMessage.textContent = 'Please accept the Terms & Conditions';
        tncContainer.appendChild(errorMessage);
      }
      return false;
    }
    this.addTocarBtn.classList.add('loading');
  }

  handleVariantChange(eventData) {
    const { container, variant } = eventData.data;
    if (container.hasAttribute('data-product-container')) {

      // Update color and size display
      const options = Array.from(container.querySelectorAll('[data-optionindex]')).map(
        option => option.querySelector('legend')?.textContent.trim().toLowerCase() || ''
      );

      // Color
      const colorIndex = options.findIndex(opt => opt.includes('color'));
      if (colorIndex !== -1 && this.productColor && variant[`option${colorIndex + 1}`]) {
        const originalValue = variant[`option${colorIndex + 1}`];
        const displayValue = this.metafieldMap[originalValue] || originalValue.toLowerCase();
        this.productColor.textContent = displayValue;
        const colorSpan = this.productColor.previousElementSibling;
        const selectedColorLabel = container.querySelector(`.swatch-label[title="${originalValue}"]`);
        if (selectedColorLabel && colorSpan) {
          colorSpan.style.backgroundColor = selectedColorLabel.style.backgroundColor;
        }
      }

      // Size
      const sizeIndex = options.findIndex(opt => opt.includes('size'));
      if (sizeIndex !== -1 && this.productSize && variant[`option${sizeIndex + 1}`]) {
        const originalValue = variant[`option${sizeIndex + 1}`];
        const displayValue = this.metafieldMap[originalValue] || originalValue;
        this.productSize.textContent = displayValue;
      }

      if (variant.available) {
        this.addTocarBtn.classList.remove('disabled');
      } else {
        this.addTocarBtn.classList.add('disabled');
      }
    }
  }

  handleProductATC() {
    if (this.addTocarBtn) {
      if (!this.termsCheckbox || this.termsCheckbox.checked) {
        this.addTocarBtn.classList.remove('loading');
      }
    }
  }

  parseMetafieldMap(metafieldString) {
    const map = {};
    if (metafieldString) {
      metafieldString.split(',').forEach(pair => {
        const [key, value] = pair.split(':');
        if (key && value) {
          map[key.trim()] = value.trim();
        }
      });
    }
    return map;
  }

  observeProductContainer() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          this.classList.add('open');
        } else {
          this.classList.remove('open');
        }
      },
      { threshold: 0 }
    );
    observer.observe(this.productContainer);
  }
}

customElements.define('product-sticky-bar', ProductStickyBar);